export default "__VITE_ASSET__BHDDTOta__"